export const listComponentOverrides = {
    MuiListItem: {
        styleOverrides: {
            root: ({ theme }) => ({
                '&.Mui-selected': {
                    backgroundColor: theme.tokens.FuelColorGreen100
                },
                '&.MuiListItem-root.Mui-selected:active': {
                    backgroundColor: theme.tokens.FuelColorGreen100
                }
            })
        }
    },
    MuiListItemButton: {
        styleOverrides: {
            root: ({ theme }) => ({
                '&:active': {
                    backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultPressed
                },
                '&.Mui-focusVisible': {
                    backgroundColor: 'transparent',
                    boxShadow: `inset 0 0 0 2px ${theme.tokens.FuelColorGray1000}`
                },
                '&.Mui-selected': {
                    backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultSelected,
                    color: theme.tokens.FuelColorBrandPrimary,
                    '&.Mui-focusVisible': {
                        backgroundColor: 'transparent'
                    },
                    '& .MuiListItemIcon-root': {
                        color: 'currentColor'
                    },
                    '&:hover': {
                        backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultSelected
                    },
                    '&:active': {
                        backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultSelected
                    },
                    '&:before': {
                        content: '""',
                        position: 'absolute',
                        width: '3px',
                        height: '100%',
                        left: 0,
                        top: 0,
                        backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultSelectedBar
                    }
                }
            })
        }
    },
    MuiListItemIcon: {
        styleOverrides: {
            root: ({ theme }) => ({
                minWidth: '40px',
                color: theme.tokens.FuelColorGray500
            })
        }
    },
    MuiListSubheader: {
        styleOverrides: {
            root: ({ theme }) => ({
                lineHeight: theme.tokens.FuelSpacing10
            })
        }
    }
};
